import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const navLinks = [
  { to: '/product', label: 'Product' },
  { to: '/features', label: 'Features' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  if (location.pathname.startsWith('/app')) return null;

  return (
    <header data-testid="main-navbar" className="sticky top-0 z-50 bg-[#0a0a1a]/70 backdrop-blur-xl backdrop-saturate-150 border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="text-xl font-black text-white tracking-tight" style={{ fontFamily: 'Outfit' }}>
          <span className="text-[#00d4ff]">D</span>QP
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(l => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm transition-colors ${location.pathname === l.to ? 'text-white font-medium' : 'text-slate-400 hover:text-white'}`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link to="/app/dashboard">
              <Button data-testid="nav-dashboard-btn" className="bg-gradient-to-r from-[#00d4ff] to-[#3b82f6] text-[#0a0a1a] font-semibold rounded-full px-6 hover:opacity-90 shadow-[0_0_20px_rgba(0,212,255,0.3)]">
                Dashboard
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/signin">
                <Button data-testid="nav-signin-btn" variant="ghost" className="text-slate-400 hover:text-white hover:bg-white/5">Sign In</Button>
              </Link>
              <Link to="/signup">
                <Button data-testid="nav-get-started-btn" className="bg-gradient-to-r from-[#00d4ff] to-[#3b82f6] text-[#0a0a1a] font-semibold rounded-full px-6 hover:opacity-90 shadow-[0_0_20px_rgba(0,212,255,0.3)]">
                  Get Started
                </Button>
              </Link>
            </>
          )}
        </div>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-white" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-[#0a0a1a]/95 backdrop-blur-xl border-b border-white/10 px-6 py-4 space-y-2">
          {navLinks.map(l => (
            <Link key={l.to} to={l.to} data-testid={`mobile-nav-${l.label.toLowerCase()}`} className="block text-slate-400 hover:text-white py-2 text-sm" onClick={() => setMobileOpen(false)}>
              {l.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-white/10 flex flex-col gap-2">
            {user ? (
              <Link to="/app/dashboard" onClick={() => setMobileOpen(false)}>
                <Button className="w-full bg-gradient-to-r from-[#00d4ff] to-[#3b82f6] text-[#0a0a1a] font-semibold rounded-full">Dashboard</Button>
              </Link>
            ) : (
              <>
                <Link to="/signin" onClick={() => setMobileOpen(false)}>
                  <Button variant="ghost" className="w-full text-slate-400">Sign In</Button>
                </Link>
                <Link to="/signup" onClick={() => setMobileOpen(false)}>
                  <Button className="w-full bg-gradient-to-r from-[#00d4ff] to-[#3b82f6] text-[#0a0a1a] font-semibold rounded-full">Get Started</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
